import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery, onSearchChange, onClearSearch }) => {
  return (
    <div className="relative w-full">
      <div className="relative">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
        </div>
        <Input
          type="search"
          placeholder="Search institutions by name, location, or program..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="pl-12 pr-12"
        />
        {searchQuery && (
          <button
            onClick={onClearSearch}
            className="absolute right-4 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-muted transition-smooth"
            aria-label="Clear search"
          >
            <Icon name="X" size={18} color="var(--color-muted-foreground)" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;